import { defa }          from 'defa-object';
import ControlModel      from 'scripts/poppet/control-model';

/**
 * defa.models.AlarmSwitch
 * The DEFA AlarmSwitch model.
 * @version 1.2.0
 */

const channel = Bb.Radio.channel( 'objects' );
const apiHost = defa.vars.apiHost;
const api = {
	linkcom: apiHost + '/linkcom/',
	alarmSwitch: '/homeAutomation/masterControl?attrs=',
};


const AlarmSwitch = ControlModel.extend( {

	url: function() {
		return api.linkcom + this.get('id') + api.alarmSwitch + this.getAttributes();
	},
	
	
	// ------------------------------------------------
	// Setup
	// ------------------------------------------------
	defaults: _.extend({}, ControlModel.prototype.defaults,
		{
			intrusionSwitch: null,
			intrusionSwitchError: null,
		
		}),
	
	// ------------------------------------------------
	// Event Handlers
	// ------------------------------------------------
	
	// ------------------------------------------------
	// Other functions
	// ------------------------------------------------

	parse: function( response, options ) {
		if(response) {
			let newModelAttributes = {};
			if(response.intrusionSwitch){
				this.parseAttribute('intrusionSwitch', response.intrusionSwitch, options, newModelAttributes)
			}
			newModelAttributes.modelError = null;
			this.receivedData( newModelAttributes );
			channel.request( 'alarmSwitchs' ).add( newModelAttributes, { merge: true } );
		}
	},

	toBackendJSON() {
		return { intrusionSwitch: 'ON' === this.get('intrusionSwitch') };
	},

	getAttributes: function() {
		return 'intrusionSwitch';
	},
	
	_getDependentModels: function(){
		let self = this;
		let dependentModels = [];
		let gpai = channel.request( 'generalAlarmInputs' ).get(self.get('id'));
		dependentModels.push(gpai);
		return dependentModels;
	}
	
} );

export default AlarmSwitch;
